module.exports = __webpack_public_path__ + "img/focus_right.00da38cd.svg";